import React from "react";
import { 
  UserPlus, 
  MapPin, 
  UserCircle, 
  BarChart3, 
  CheckCircle2, 
  ArrowRight,
  ClipboardList
} from "lucide-react";

// --- SUB-COMPONENT: CHECKLIST ITEM ---
const StepCard = ({ number, title, description, icon: Icon, status, onNavigate, targetId }) => (
  <div 
    onClick={() => onNavigate(targetId)}
    className={`group relative bg-white border ${status === 'complete' ? 'border-green-200 bg-green-50/30' : 'border-gray-200'} rounded-2xl p-6 transition-all hover:shadow-md cursor-pointer`}
  >
    <div className="flex gap-5">
      <div className="flex-shrink-0">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${status === 'complete' ? 'bg-green-100 text-green-600' : 'bg-blue-50 text-blue-600'}`}>
          <Icon size={24} />
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[10px] font-black text-blue-500 uppercase tracking-widest">Step {number}</span>
          {status === 'complete' && <CheckCircle2 size={14} className="text-green-500" />}
        </div>
        <h3 className="text-lg font-bold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-500 leading-relaxed mb-4">{description}</p>
        
        <button className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider transition-all ${status === 'complete' ? 'text-green-600' : 'text-blue-600 hover:gap-3'}`}>
          {status === 'complete' ? 'View Details' : 'Go to Section'} 
          <ArrowRight size={14} />
        </button>
      </div>
    </div>
  </div>
);

// --- MAIN PAGE COMPONENT ---
// We pass 'onNavigate' as a prop from the parent AthleteDocs
const OnboardingPage = ({ onNavigate }) => {
  return (
    <div className="space-y-10 pb-20">
      <section className="text-center md:text-left">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-100 mb-4">
          <ClipboardList size={14} className="text-blue-600" />
          <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">Getting Started Checklist</span>
        </div>
        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Athlete Setup Checklist</h1>
        <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
          Complete these steps to activate your Nuvio Sport profile and AI engine.
        </p>
      </section>

      <div className="grid gap-4">
        <StepCard 
          number="1"
          title="Create Your Account"
          description="Login and verify your email to initialize your training dashboard."
          icon={UserPlus}
          status="complete"
          targetId="create" // Stay here or go to Dashboard
          onNavigate={onNavigate}
        />

        <StepCard 
          number="2"
          title="Follow a Program"
          description="Visit the Marketplace to connect with your team and unlock benchmarks."
          icon={MapPin}
          status="pending"
          targetId="marketplace"
          onNavigate={onNavigate}
        />

        <StepCard 
          number="3"
          title="Verify Initial Scores"
          description="Establish your baseline by entering your latest skill and combine stats."
          icon={BarChart3}
          status="pending"
          targetId="metrics"
          onNavigate={onNavigate}
        />
        
        <StepCard 
          number="4"
          title="Complete Identity Profile"
          description="Set your address and Modeled Player in your profile settings."
          icon={UserCircle}
          status="pending"
          targetId="profile"
          onNavigate={onNavigate}
        />

      </div>
    </div>
  );
};

export default OnboardingPage;